<script>
  import { createEventDispatcher, onMount, onDestroy } from 'svelte';
  import {get} from 'svelte/store'
  import Select from 'svelte-select';
  import request from 'superagent';
  import { Editor, Extension } from '@tiptap/core';
  import StarterKit from '@tiptap/starter-kit';
  import Link from '@tiptap/extension-link';
  import suggestion from './item_suggestion.js';
  import Commands from '../../../../../components/tiptap/commands';
  import ItemSuggestions from './ItemSuggestions.svelte';
  import { slashVisible, unsavedSubitems } from './stores.js';
  
  import { topics as default_topics_store } from '../stores.js'
  import FeedUsageForm from "./FeedUsage.svelte";
  import LinkForm from "./Link.svelte";
  import SubitemForm from "./Subitem.svelte";
  import VideoForm from "./Video.svelte";
  
  const LINKS_CONTENT = 1;
  const VIDEOS_CONTENT = 2;
  const ITEMS_CONTENT = 3;
  const FEEDS_CONTENT = 4;
  const defaultItem = {
    id: null, topic_id: null, kind: LINKS_CONTENT, title: "", about: "", tags: "",
    links: [], videos: [], subitems: [], feeds: []
  }
  const defaultLink = { id: null, language: "cz", title: "", uri: "" }
  const defaultSubitem = { id: null, about: "", tag: "", item_id: null, subitem_id: null, subitem_type: null }
  const defaultVideo = { id: null, video_id: null, language: "cz", title: "", uri: "", channel_name: "", image: ""}
  const dispatch = createEventDispatcher();
  
  export let item_form_id = null;
  export let link_form_id = window.LINK_FORM_ID;
  export let video_form_id = window.VIDEO_FORM_ID;
  export let subitem_form_id = window.SUBITEM_FORM_ID;
  
  export let item = Object.assign({}, defaultItem);
  export let topics_store = default_topics_store;
  
  let topics = [];
  let unsaved_subitems = [Object.assign({}, defaultSubitem)];
  let grouped_subitems = groupBy([].concat(unsaved_subitems, []), "tag");
  let response = null;
  
  let visible_content = LINKS_CONTENT;
  
  let trash_links = [];
  
  let editor;
  let element;
  
  let selectedIndex = 0;
  $: selectedIndex = $slashVisible ? selectedIndex : 0;
  
  topics_store.subscribe(value => {
    if (value  != 'undefined' || !value)
      topics = value;
  });
  
  unsavedSubitems.subscribe(value => {
    if (value  != 'undefined' || !value)
      addSubitem({detail: value, suggestion: true})
  });
  
  function groupBy(items, key) {
    if (!Array.isArray(items))
      return {};
    return items.reduce( (result, item, i) => ({
        ...result,
        [item[key]]: [
          ...(result[item[key]] || []),
          item,
        ],
      }),
      {},
    )
  }
  
  function addLink() {
    if (!item['links']) {
      item.links = [];
    }
    item.links = [Object.assign({}, defaultLink), ...item.links]
    visible_content = LINKS_CONTENT;
  }
  
  function addSubitem(ev) {
    if (!item['subitems']) {
      item.subitems = [];
    }
    if (ev && ev.detail) {
      let subitem = ev.detail;
  
      if (Array.isArray(ev.detail)) {
        grouped_subitems[null] = ev.detail
      } else {
        grouped_subitems[subitem.tag][subitem.position] = subitem;
      }
      unsaved_subitems = [].concat.apply([], Object.values(grouped_subitems));
    }
  
    if (!ev || !ev.suggestion)
      unsaved_subitems = [Object.assign({}, defaultSubitem), ...unsaved_subitems];
  
    grouped_subitems = groupBy([].concat(unsaved_subitems, item.subitems), "tag");
    visible_content = ITEMS_CONTENT;
  }
  
  function addFeedUsage(ev) {
    if (!item['feed_ids']) {
      item.feed_ids = [];
      return;
    }
    item.feed_ids.push(ev.detail.id);
    item.feeds = [ev.detail, ...item.feeds];
    console.log("addFeedUsage", item)
  }
  
  function addVideo(ev) {
    if (!item['videos']) {
      item.videos = [];
    }
    if (ev && ev.detail)
      item.videos = [Object.assign(ev.detail, defaultVideo), ...item.videos]
    else
      item.videos = [Object.assign({}, defaultVideo), ...item.videos]
    visible_content = VIDEOS_CONTENT;
  }
  
  function removeLink(index) {
    item.links[index]["item_id"] = null;
    trash_links.push(item.links[index]);
    let tmp = item.links;
    tmp.splice(index, 1);
    item.links = tmp;
    if (!item.links.length) {
      item.links = null;
    }
  }
  
  function removeSubitem(index, subitem) {
    let i = index;
    if (subitem && !subitem.id) {
      i = unsaved_subitems.indexOf(subitem);
      unsaved_subitems.splice(i, 1);
    } else {
      let tmp = item.subitems;
      if (subitem)
        i = tmp.indexOf(subitem);
  
      tmp.splice(i, 1);
      item.subitems = tmp;
      if (!item.subitems.length) {
        item.subitems = [];
      }
    }
    grouped_subitems = groupBy([].concat(unsaved_subitems, item.subitems), "tag");
  }
  
  function removeVideo(index) {
    item.videos[index]["item_id"] = null;
    let tmp = item.videos;
    tmp.splice(index, 1);
    item.videos = tmp;
    if (!item.videos.length) {
      item.videos = null;
    }
  }
  
  function removeFeedUsage(index) {
    if (!item['feed_ids']) {
      return;
    }
    let tmp = item.feed_ids || [];
    tmp.splice(index, 1);
    item.feed_ids = tmp;
  
    tmp = item.feeds || [];
    tmp.splice(index, 1);
    item.feeds = tmp;
  
  }
  
  function showLinks() {
    if (!Array.isArray(item['links']))
      item['links'] = [];
    visible_content = LINKS_CONTENT;
    if (!item.links.length)
      addLink();
  }
  
  function showSubitems() {
    if (!Array.isArray(item['subitems']))
      item['subitems'] = [];
    visible_content = ITEMS_CONTENT;
    if (!item.subitems.length && !unsaved_subitems.length)
      addSubitem();
  }
  
  function showVideos() {
    if (!Array.isArray(item['videos']))
      item['videos'] = [];
    visible_content = VIDEOS_CONTENT;
    if (!item.videos.length)
      addVideo();
  }
  
  function showFeedUsages() {
    visible_content = FEEDS_CONTENT;
    if (!Array.isArray(item['feeds'])) {
      fetch(`/p/news/items/${item.id}/feeds.json`)
        .then(r => r.json())
        .then(data => {
          if (data != null && Object.keys(data).length > 0) {
            if (!Array.isArray(data))
              item.feeds = [data];
            else
              item.feeds = data || [];
          }
        });
    }
  }
  
  function cancel() {
    dispatch('item', null);
  }
  
  function commit() {
    if (!item['title'] || !item['title'].length) {
      alert("Titulek musí být vyplněn.");
      return;
    }
    if (item['feed_ids'] && !item['feed_ids'].length) {
      delete item['feed_ids'];
    }
    item['about'] = editor.getHTML()
    let submit = item.id ? request.put : request.post;
  
    submit(`/form/${item_form_id}`)
    .send(Object.assign({}, item))
    .then(resp => {
      if (!item.id)
        item.id = resp.body.id;
  
      saveLinks(trash_links, null);
  
      saveLinks(item.links, window.btoa(item.id+""));
      saveVideos(window.btoa(item.id+""));
      saveSubitems(window.btoa(item.id+""));
  
      dispatch('message', item);
      if (resp.body.success) {
        response = {success: true, message: "Uloženo."}
      } else {
        response = {message: "Soubor nešlo uložit."}
      }
      setTimeout(() => response = null, 3000);
      //window.major.update();
    });
  
  }
  
  function saveLinks(links, item_id) {
    // TODO batch
    if (!Array.isArray(links))
      return;
    for (const link of links) {
      let submit = link.id ? request.put : request.post;
      submit(`/form/${link_form_id}`)
      .send(Object.assign({item_id: item_id}, link))
      .then(resp => {
        link.id = resp.body.id;
      })
      .catch(resp => {
        console.log("problem detected when commiting link")
      });
    }
  }
  
  function saveVideos(item_id) {
    // TODO batch
    if (!Array.isArray(item['videos']))
      return;
    for (const video of item.videos) {
      if (!video.id && video["from_feed"])
        continue;
  
      let submit = video.id ? request.put : request.post;
      submit(`/form/${video_form_id}`)
      .send(Object.assign({item_id: item_id}, video))
      .then(resp => {
        video.id = resp.body.id;
      })
      .catch(resp => {
        console.log("problem detected when commiting video")
      });
    }
  }
  
  function saveSubitems(item_id) {
    // TODO batch
    if (!Array.isArray(unsaved_subitems))
      return;
    for (const item of unsaved_subitems) {
      if (!item.subitem_id || !item.subitem_type)
        continue;
      let submit = item.id ? request.put : request.post;
      submit(`/form/${subitem_form_id}`)
      .send(Object.assign({}, item, {item_id: item_id}))
      .then(resp => {
        item.id = resp.body.id;
      })
      .catch(resp => {
        console.log("problem detected when commiting subitem")
      });
    }
    item.subitems = [...unsaved_subitems, ...item.subitems];
    unsaved_subitems = [];
    grouped_subitems = groupBy(item.subitems, "tag");
  }
  
  onMount(() => {
    // showFeedUsages();
    editor = new Editor({
      element: element,
      extensions: [
        StarterKit,
        Link.configure({
          openOnClick: false,
        }),
        Commands.configure({ suggestion })
      ],
      editorProps: {
        attributes: {
          class: 'droplet',
        },
      },
      content: item['about'],
      onTransaction: () => {
        editor = editor // force re-render so `editor.isActive` works as expected
      },
    })
  });
  
  onDestroy(() => {
    if (editor) {
      editor.destroy()
    }
  })
  
  export function dragover(ev) {
    ev.preventDefault();
    ev.dataTransfer.dropEffect = 'move';
  }
  
  export function linkFromPost(ev) {
    ev.preventDefault();
    var post = JSON.parse(ev.dataTransfer.getData("text"));
    if (post['video_id']) {
      if (!item['videos'])
        item.videos = [];
      item.videos = [Object.assign({}, defaultVideo, post), ...item.videos];
    } else {
      if (!item['links'])
        item.links = [];
      item.links = [Object.assign({}, defaultLink, post), ...item.links];
    }
  }
</script>
<div class='d-flex justify-content-between'>
<div class='d-item'>
<button class='btn btn-outline-secondary border-0' on:click='{cancel}'>
<i class='fa fa-times'></i>
</button>
<button class:btn-outline-primary='{!item.title}' class='btn border-0 btn-primary' disabled='{!item.title}' on:click|preventDefault='{() => commit()}' type='submit'>
<i class='fa fa-save'></i>
<div class='d-none d-md-inline'>
Uložit
</div>
</button>
</div>
<div class='d-item'>
{#if !item  || !(item.title || item.links || item.videos)}
<div class='alert alert-info'>
V souboru lze uložit navzájem související odkazy a média.
</div>
{/if}
</div>
</div>
<div class='bg-white shadow p-1 my-1'>
<form action='/form/{item_form_id}' on:dragover='{dragover}' on:drop='{event => linkFromPost(event)}'>
<div class='row'>
<fieldset class='form-group col-12'>
<label class='form-text text-muted' for='item-title'>Název souboru</label>
<input bind:value='{item.title}' class='form-control ui' id='item-title' placeholder='Titulek' type='text'>
</fieldset>
<fieldset class='form-group col-12'>
<label class='form-text text-muted' for='item-topics'>Složka</label>
<select bind:value='{item.topic_id}' class='form-control ui' id='item-topics'>
{#each topics as t}
<option value='{t.id}'>{t.title}</option>
{#each t.children as c}
<option value='{c.id}'>{t.title} &gt; {c.title}</option>
{#if c.children}{#each c.children as d}
<option value='{d.id}'>{t.title} &gt; {c.title} &gt; {d.title}</option>
{#if d.children}{#each d.children as e}
<option value='{e.id}'>{t.title} &gt; {c.title} &gt; {d.title} &gt; {e.title}</option>
{/each}{/if}
{/each}{/if}
{/each}
{/each}
<option value=''></option>
</select>
</fieldset>
<fieldset class='form-group col-12'>
<label class='form-text text-muted' for='item-about'>Text</label>
<div bind:this='{element}' class='form-control ui h-auto' id='item-about' placeholder='O čem to je...' rows='2' type='text'></div>
{#if editor}
<div class='d-flex justify-content-start'>
<div class='econtrol d-flex justify-content-around w-50'>
<div class='btn-group'>
<button class:active='{() => editor.isActive('italic')}' class='btn btn-sm' on:click|preventDefault='{() => editor.chain().focus().toggleItalic().run()}'>
<em>
I
</em>
</button>
<button class:active='{() => editor.isActive('bold')}' class='btn btn-sm' on:click|preventDefault='{() => editor.chain().focus().toggleBold().run()}'>
<strong>
B
</strong>
</button>
</div>
</div>
</div>
<ItemSuggestions selectedIndex='{selectedIndex}'></ItemSuggestions>
{/if}
</fieldset>
</div>
</form>
{#if response}
<div class:alert-success='{response.success}' class:alert-warning='{!response.success}' class='alert'>
{response.message}
</div>
{/if}
<nav class='w-100 mt-2'>
<ul class='nav nav-tabs'>
<li class='nav-item flex-sm-fill' on:click='{showLinks}'>
<div class:active='{visible_content == LINKS_CONTENT}' class='nav-link flex-row d-flex'>
<div class='form-check form-check-inline mr-0'>
<input bind:group='{item.kind}' checked='{item.kind == LINKS_CONTENT}' class='form-check-input' name='item-kind-links' title='Zobrazit ve výpisu odkazy' type='radio' value='{LINKS_CONTENT}'>
</div>
<div class='btn btn-outline-link border-0'>
odkazy
</div>
<small class='btn btn-outline-primary border-0' on:click='{addLink}' title='Přidat další odkaz'>
<i class='fa fa-plus'></i>
</small>
</div>
</li>
<li class='nav-item flex-sm-fill' on:click='{showVideos}'>
<div class:active='{visible_content == VIDEOS_CONTENT}' class='nav-link flex-row d-flex'>
<div class='form-check form-check-inline mr-0'>
<input bind:group='{item.kind}' class='form-check-input' name='item-kind-videos' title='Zobrazit ve výpisu videa' type='radio' value='{VIDEOS_CONTENT}'>
</div>
<div class='btn btn-outline-link border-0'>
videa
</div>
<small class='btn btn-outline-primary border-0' on:click='{addVideo}' title='Přidat další video'>
<i class='fa fa-plus'></i>
</small>
</div>
</li>
<li class='nav-item flex-sm-fill' on:click='{showSubitems}'>
<div class:active='{visible_content == ITEMS_CONTENT}' class='nav-link flex-row d-flex'>
<div class='btn btn-outline-link border-0'>
souvislosti
</div>
</div>
</li>
<li class='nav-item flex-sm-fill' on:click='{showFeedUsages}'>
<div class:active='{visible_content == FEEDS_CONTENT}' class='nav-link flex-row d-flex'>
<div class='btn btn-outline-link border-0'>
odběry
</div>
</div>
</li>
</ul>
</nav>
<div class='d-block p-1'>
{#if visible_content == LINKS_CONTENT}
{#if item && item.links}
<ol class='links list-group list-group-flush'>
{#each item.links as link, i}
<li class='list-group-item border-0'>
<LinkForm form_id='{link_form_id}' item_id='{item.id}' link='{link}' on:remove='{() => removeLink(i)}' show_label='{i==0}'></LinkForm>
</li>
{/each}
</ol>

{/if}
{:else if visible_content == ITEMS_CONTENT}
{#if item && item.subitems }
<div class='row'>
<div class='col-12'>
<label class='form-text text-muted'>Text</label>
{#each Object.entries(grouped_subitems) as [tag, subitems]}
{#if tag != 'null'}
<h2>
{tag}
</h2>
{/if}
<div class='subitems'>
{#each subitems as subitem, i }
<div class='border-0'>
<SubitemForm item_id='{item.id}' on:remove='{() => removeSubitem(i, subitem)}' on:subitem='{addSubitem}' position='{i}' subitem='{subitem}'></SubitemForm>
</div>
{/each}
</div>
{/each}
</div>
</div>

{/if}
{:else if visible_content == FEEDS_CONTENT}
<FeedUsageForm on:feed='{addFeedUsage}' show_label='{true}'></FeedUsageForm>
{#if item.feeds}
<ol class='links list-group list-group-flush'>
{#each item.feeds as feed, i}
<li class='list-group-item border-0 d-flex flex-row justify-content-between'>
<span>{feed.name}</span>
<button class='btn btn-outline-danger border-0' on:click='{removeFeedUsage(i)}' role='button'>
<i class='fa fa-trash'></i>
</button>
</li>
{/each}
</ol>
{/if}

{:else}
{#if item && item.videos && item.videos.length}
<ol class='links list-group list-group-flush'>
{#each item.videos as video, i}
<li class='list-group-item border-0'>
<VideoForm item_id='{item.id}' on:remove='{() => removeVideo(i)}' show_label='{i==0}' video='{video}'></VideoForm>
</li>
{/each}
</ol>
{/if}
{/if}
</div>
</div>

